/**
 * Simple utility to standardize upload filenames to "original" + extension
 */

/**
 * Converts any filename to standardized format: "original" + file extension
 * @param originalName - The original filename (e.g., "my-video.mp4")
 * @returns Standardized filename (e.g., "original.mp4")
 */
export const getStandardizedFileName = (originalName: string): string => {
  const lastDotIndex = originalName.lastIndexOf('.');
  const extension =
    lastDotIndex !== -1 ? originalName.substring(lastDotIndex) : '';
  return `original${extension}`;
};
